export default __webpack_public_path__ + "static/media/man2.753accdc.jpg";